import Vue from 'vue'
import App from './App.vue'
// import router from './router'
// import store from './store'
// import "./filters"

///////////////////////////////////////

Vue.config.productionTip = false


///////////////////////////////////////

// //Use Font Awesome

/**/
import { library } from '@fortawesome/fontawesome-svg-core'
// import { far } from '@fortawesome/pro-regular-svg-icons'
// import { fas } from '@fortawesome/pro-solid-svg-icons'
// import { fal } from '@fortawesome/pro-light-svg-icons'
import { faBackspace, faCheck } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// library.add(far, fas, fal);
library.add(faBackspace)
library.add(faCheck);
Vue.component('font-awesome-icon', FontAwesomeIcon)

/**/
///////////////////////////////////////

//Use Buefy
//import Buefy from 'buefy';
// import 'buefy/dist/buefy.css'; // Import with SCSS instead

// Vue.use(Buefy, {
//     defaultIconPack: 'far',
//     defaultIconComponent: FontAwesomeIcon,

// });

///////////////////////////////////////

//Initialize and mount the Vue APP
new Vue({
    render: h => h(App)
}).$mount('#app')